import firebaseService from '../firebase/FirebaseService';
import { getCycleById, updateCycle } from './CycleService';
import { addStudentToGroup, removeStudentFromGroup } from './NewGroupService';
// import { updateUser } from './UserService';

export const createGroup = async (payload, addUsersGroup) => {
    return firebaseService
        .createGroup(payload)
        .then(async (response) => {
            const groupId = response.id;

            if (addUsersGroup) {
                const userResponse = await updateUsersProcess(groupId, addUsersGroup)
                    .then((response) => {
                        return response;
                    })
                    .catch(e => {
                        return "error";
                    });

                if (userResponse === "error")
                    return { type: "error", message: "Error al asignar el grupo a los usuarios" };
            }

            return { type: "success", message: "El grupo se creo con exito!", data: groupId };
        })
        .catch(e => {
            return { type: "error", message: "Error al crear el grupo" };
        });
}

export const updateGroup = async (groupId, payload, addUsersGroup, removeUsersGroup) => {
    return firebaseService
        .updateGroup(groupId, payload)
        .then(async (response) => {
            const userResponse = await updateUsersProcess(groupId, addUsersGroup, removeUsersGroup)
                .then((userResponse) => {
                    return userResponse;
                })
                .catch(e => {
                    return "error";
                });

            if (userResponse === "error")
                return { type: "error", message: "Error al asignar el grupo a los usuarios" };

            // const cycleResponse = await updateCycleProcess(groupId, payload, "update")
            //     .then((userResponse) => {
            //         return userResponse;
            //     })
            //     .catch(e => {
            //         return "error";
            //     });

            // if (cycleResponse === "error") {
            //     return { type: "error", message: "Error al modificar el ciclo del grupo" };
            // }

            return { type: "success", message: "El grupo se actualizo con exito!", data: response };
        })
        .catch(e => {
            return { type: "error", message: "Error al actualizar el grupo" };
        });
}

export const updateUsersProcess = async (groupId, addUsers, removeUsers) => {
    const userFunctions = [];

    if (addUsers) {
        addUsers.forEach(user => {
            userFunctions.push(addStudentToGroup(user.id, groupId));
        });
    }

    if (removeUsers) {
        removeUsers.forEach(user => {
            userFunctions.push(removeStudentFromGroup(user.id, groupId));
        });
    }

    return Promise.all(userFunctions).then((response) => {
        return Promise.resolve(response);
    }).catch(error => {
        return Promise.reject({
            error: error
        });
    });
}

export const updateCycleProcess = async (groupId, group, type) => {
    return getCycleById(group.cycle_id)
        .then((cycle) => {
            if (cycle.groups) {
                const cycleGroups = cycle.groups.filter((cGroup) => cGroup.id !== groupId);

                if (type === "update")
                    cycleGroups.push({ id: groupId, name: group.name });

                updateCycle(cycle.id, { groups: cycleGroups })
                    .then((uCycleResp) => {
                        return { type: "success", value: uCycleResp };
                    }).catch(error => {
                        return { type: "error", value: error };
                    });
            } else {
                return "";
            }
        })
}

export const disableGroup = async (group, removeUsersGroup) => {
    const groupId = group.id;
    const payload = { deleted: true, cycle_id: "", cycle_name: "", users: [] };
    return firebaseService.updateGroup(groupId, payload)
        .then(async (response) => {
            if (removeUsersGroup) {
                const userResponse = await updateUsersProcess(groupId, "", null, removeUsersGroup)
                    .then((userResponse) => {
                        return userResponse;
                    })
                    .catch(e => {
                        return "error";
                    });

                if (userResponse === "error")
                    return { type: "error", message: "Error al desasignar el grupo a los usuarios" };
            }

            const cycleResponse = await updateCycleProcess(groupId, group, "delete")
                .then((userResponse) => {
                    return userResponse;
                })
                .catch(e => {
                    return "error";
                });

            if (cycleResponse === "error") {
                return { type: "error", message: "Error al desasignar el grupo del ciclo" };
            }

            return { type: "success", message: "El grupo se deshabilito con exito!" };;
        })
        .catch(e => {
            return { type: "error", message: "Error al deshabilitar el grupo" };
        });
}

export const deleteGroupUsers = async (users) => {
    return firebaseService.deleteGroupUsers(users)
        .then((response) => {
            return response;
        })
        .catch(e => {
            return "error";
        });
}

export const updateGroupsCycle = async (cycleId, cycleName, removeGroupsCycle, addGroupsCycle) => {
    return firebaseService.updateGroupsCycle(cycleId, cycleName, removeGroupsCycle, addGroupsCycle)
        .then((response) => {
            return response;
        })
        .catch(e => {
            return "error";
        });
}

export const getGroups = async () => {
    return firebaseService.getGroups()
        .then((response) => {
            return response;
        })
        .catch(error => {
            return [];
        });
};

export const getGroupById = async (groupId) => {
    return firebaseService.getGroupById(groupId)
        .then((response) => {
            return response;
        })
        .catch(error => {
            return {};
        });
};

export const getGroupsByCycleId = async (cycleId) => {
    return firebaseService.getGroupsByCycleId(cycleId)
        .then((response) => {
            return response;
        })
        .catch(error => {
            return [];
        });
};

export const getGroupsWithoutCycle = async () => {
    return firebaseService.getGroupsWithoutCycle()
        .then((response) => {
            return response;
        })
        .catch(error => {
            return [];
        });
};